// extracted by mini-css-extract-plugin
export default {"navigationBarBottom":"NavigationPanel_navigationBarBottom__exqR5","analyticsSwitch":"NavigationPanel_analyticsSwitch__77CvM"};